import { createPalette } from '../transforms';
import { type PaletteCommandDef, PaletteCommandType, type PaletteDef } from '../types';

export type PaletteRadioOption<Value> = {
    value: Value;
} & Pick<PaletteCommandDef, 'title' | 'subtitle' | 'icon'>;

/**
 * Utility to create a radio palette, where the user can select one of the options.
 */
export function createRadioPalette<Value extends string>({
    value,
    options,
    onSelect,
}: {
    /** Current value */
    value: Value;
    /** Options to choose from */
    options: PaletteRadioOption<Value>[];
    /** Callback to call when the user selects an option */
    onSelect: (value: Value) => void;
}): PaletteDef {
    return createPalette({
        groups: [
            {
                key: 'options',
                commands: options.map((option) => ({
                    key: option.value,
                    ...option,
                    type: PaletteCommandType.RADIO,
                    selected: option.value === value,
                    trigger: () => onSelect(option.value),
                })),
            },
        ],
    });
}
